import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToggle } from "../../store/doctor/sidebarSlice";

export const useSidebarStore = () => {
  const dispatch = useDispatch();

  const { toggle } = useSelector((state) => state.doctor.sidebar);

  const invertToggle = useCallback(() => {
    dispatch(setToggle(!toggle));
  }, [dispatch, toggle]);

  return {
    // Props
    toggle,

    // Methods
    invertToggle,
  };
};
